import React, { useEffect, useState,useRef } from "react";
import { Button, Col, Modal, Row, Spinner, Form } from "react-bootstrap";
import LoginForm from "./LoginForm";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "../../styles/login-register.css";
import { Link, useNavigate } from "react-router-dom";
import customerRegistration from "../../services/customer-service";
import { ErrorHandlingDesign } from "../common/errorHandlingDesign";
import { handleErrors } from "../../utils/errorHandler";
import { useUser } from "../context/UserContext";
import {useLoginModal} from  "../context/LoginPopUpContext"
import {useBuyWishlist} from "../context/BuyContext"
import { set } from "lodash";
 import Cookies from "js-cookie";
import {
  validateContactNumber,
  validateOtp,
} from "../../utils/validation/validate-login";
import {
  validateFirstName,
  validateLastName,
  validateEmail,
  validatePhoneNo,
  validateLinkedInProfile,
} from "../../utils/validation/validate-register";
import { toast } from "react-toastify";
import { Today } from "@mui/icons-material";
import { Toast } from "bootstrap";

export default function LoginPopUp({ show, close, action=null,resetVisitCount }) {
  const [LoginPage, SetLoginPage] = useState(true);
  //this states are used to handle the login
  const [contactNumber, setContactNumber] = useState("");
  const [contactError, setContactError] = useState("");
  const [isRequestOtpDisabled, setIsRequestOtpDisabled] = useState(false);
  const [isOtpFormActive, setIsOtpFormActive] = useState(false);
  const [apiError, setApiError] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [resendTimer, setResendTimer] = useState(60);
   const [otpError, setOtpError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);

  //this state is used to manage the registration data.
   const [formData, setFormData] = useState({
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNo: "",
      whatsApp: "No",
      includeLinkedIn: false,
      linkedInProfile: "",
    });
  const [errors, setErrors] = useState({});
  const [registerError, setRegisterError] = useState(null);
  const [custGuid, setCustGuid] = useState("");//this one is used to store the guid of customer which helps to register and request otp based on that
  const { setAuthentication } = useUser();
   const inputRefs = useRef([]);
  const navigate = useNavigate();
   const { user, setPendingAction, pendingAction } = useUser();
   const{addToBuyWishlist}=useBuyWishlist();
   const{isForceLogin}=useLoginModal()
//=-----------------------------------------------------------------------------------------------------------
// these function are used to carry out the actionset when user login popup comes
//-------------------------------------------------------------------------------------------------------------
//here we are using this logic because when we log in states take some time update but before that my add to wishlist function
//will call due to this after login also it will give please login to add to wish list. here we are adding the action to pending action state once the user authenticated set then only call the add to wish list.
const addtoWishList=async(action)=>
{ 
  if(!user.isAuthenticated)
  {
    setPendingAction(action.FlatId)
  }
  else
  {
    addToBuyWishlist(action.FlatId);
  }
   
}

useEffect(()=>{
  if(user.isAuthenticated && pendingAction)
  {
    addToBuyWishlist(pendingAction)
    setPendingAction(null)
    //once login we are clearning the page count visit to 0
    // localStorage.setItem("visitPageCount", 0);
    // console.log
  }

},[user.isAuthenticated])
//this is the general state reset function
// Add this function to reset all states
const resetAllStates = () => {
  setContactNumber("");
  setContactError("");
  setIsRequestOtpDisabled(false);
  setIsOtpFormActive(false);
  setApiError("");
  setIsLoggedIn(false);
  setCanResendOtp(false);
  setResendTimer(60);
  setOtpError("");
  setIsSubmitting(false);
  setOtp(["", "", "", ""]);

  setFormData({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNo: "",
    whatsApp: "No",
    includeLinkedIn: false,
    linkedInProfile: "",
  });
  setErrors({});
  setRegisterError(null);
  
  // Reset to login page
  SetLoginPage(true);
};
  //------------------------------------------------------------------------------------------------------------------------------
  //this logic is used to handle login
  //------------------------------------------------------------------------------------------------------------------------------

  //handle ot change
  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      document.getElementById(`otp-digit-${index + 1}`).focus();
    }
  };
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-digit-${index - 1}`).focus();
    }
  };

  //this function will call api to get the otp in both login and register also

  const handleRequestOtp = async (requestfrom) => {
    if(requestfrom==="login")
    {
    const formattedNumber = contactNumber.replace(/^\+91/, "");
    const error = validateContactNumber(formattedNumber);

    if (error) {
      setContactError(error);
    } else {
      setContactError("");
      setIsRequestOtpDisabled(true);
      try {
        const response = await customerRegistration.postRequestOtp(
          formattedNumber
        );
        if (response.data.isSuccess) {
          setIsOtpFormActive(true);
          setApiError("");
          startTimer();
        } else {
          setApiError("Failed to send OTP. Please try again.");
        }
      } catch (err) {
        setIsLoggedIn(true);
      } finally {
        setIsRequestOtpDisabled(false);
      }
    }
  }
  else
  {
    // if the user is trying to register
    //check if there is any error
     const newErrors = {};
        newErrors.firstName = validateFirstName(formData.firstName);
        newErrors.lastName = validateLastName(formData.lastName);
        newErrors.emailAddress = validateEmail(formData.emailAddress);
    
        const formattedPhoneNo = formData.phoneNo
          ? formData.phoneNo.replace(/^\+91/, "").trim()
          : "";
        newErrors.phoneNo = validatePhoneNo(formattedPhoneNo);
        newErrors.linkedInProfile = validateLinkedInProfile(
          formData.linkedInProfile,
          formData.includeLinkedIn,
        );
         if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }
     const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      emailAddress: formData.emailAddress,
      phoneNo: formattedPhoneNo,
      whatsApp: formData.whatsApp,
      linkedInProfile: formData.includeLinkedIn
        ? formData.linkedInProfile.trim()
        : "",
      pwd: "Hello@123",
    };
    setIsRequestOtpDisabled(true);
   setIsSubmitting(true);
      try {
      const response = await customerRegistration.postCustomerRegistration(
        payload
      );
      setIsOtpFormActive(true);
      startTimer();
      setCustGuid(response.data.result.cust_id);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        console.error("Registration conflict: User already exists.");
        setRegisterError(error.response.data.message);
      } else {
        const errorMessage = handleErrors(error);
        setApiError(errorMessage);
      }
    } finally {
      setIsRequestOtpDisabled(false);
      setIsSubmitting(false);
    }
  }
  };

  //this func is used to show timer
  const startTimer = () => {
    setCanResendOtp(false);
    setResendTimer(60);
    const timer = setInterval(() => {
      setResendTimer((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setCanResendOtp(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
     return () => clearInterval(timer);
  };

  //this func is for when user press enter key otp should request
  const handleEnterKeyPressForPhone = (e,reqfrom) =>{
    if (e.key === "Enter" && contactNumber) {
      e.preventDefault();
      handleRequestOtp(reqfrom);
      // handleSubmitOtp();
    }
  };

  const handleResendOtp = async (reqfrom) => {
    if(reqfrom="login")
    {
      
    
    const formattedNumber = contactNumber.replace(/^\+91/, "");

    try {
      const response = await customerRegistration.postResendOtpLogin(
        formattedNumber
      );
      if (response.data.isSuccess) {
        setApiError("");
        startTimer();
      } else {
        setApiError("Failed to resend OTP. Please try again.");
      }
    } catch (err) {
      const errorMessage = handleErrors(err);
      setApiError(errorMessage);
    }
  }
  else{
    // if the request from register form
     try {
      const response = await customerRegistration.postresendOtp(custGuid);
      setResendTimer(60);
      startTimer();
      setCanResendOtp(false);
    } catch (error) {
      const errorMessage = handleErrors(error);
      setApiError(errorMessage);
    }
  }
  };

  const handleSubmitOtp = async (reqfrom) => {
    if(reqfrom==="login")
    {
      
    
    const formattedNumber = contactNumber.replace(/^\+91/, "");
    const error = validateOtp(otp);

    if (error) {
      setOtpError(error);
    } else {
      setOtpError("");
      setIsSubmitting(true);
      try {
        const otpString = otp.join("");
        const response = await customerRegistration.verifyOtpLogin(
          formattedNumber,
          otpString
        );
      
        if (response.data.isSuccess === true) {
         
          const accessToken = Cookies.get("accessToken");
         
          if (accessToken) {
            
           await setAuthentication(!!accessToken);
            
          } else {
            
            setAuthentication(null);
           
          }
          resetVisitCount()
         resetAllStates();
          close();

          if(action)
          {
            
            if(action.actionName==="addtoWishList")
            {
              
              // call the add to wish list function
              addtoWishList(action)
            }
          }
        
        } else 
          {
            
          setOtpError("Invalid OTP. Please try again.");
        }
      } catch (err) {
        // const errorMessage = handleErrors(err);
        
        setOtpError("Invalid OTP. Please try again.");
        // setApiError(errorMessage);
      } finally {
        setIsSubmitting(false);
      }
    }
  }
  else{
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 4) {
      setOtpError("Please enter a complete 4-digit OTP.");
      return;
    }
     setOtpError("");
    setIsSubmitting(true);
    try {
      const response = await customerRegistration.verifyOtp(
        custGuid,
        enteredOtp
      );

      if (response.data.isSuccess) {
        const accessToken = Cookies.get("accessToken");

        if (accessToken) {
          setAuthentication(!!accessToken);
        } else {
          setAuthentication(null);
        }
           resetAllStates();  
  close();
   if(action)
          {
            
            if(action.actionName==="addtoWishList")
            {
              
              // call the add to wish list function
              addtoWishList(action)
            }
          }
      
      } else {
       
        setOtpError("Invalid OTP. Please try again.");
        
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setOtpError(error.response.data.message);
      } else {
        setOtpError("OTP verification failed. Please try again.");
      }

      
    } finally {
       setIsSubmitting(false);
    }
  
  }
  };

//--------------------------------------------------------------------------------------------------------------------------------
// this is the end of login form logic
//--------------------------------------------------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------------------------------
//from this func is used to register the new user
//----------------------------------------------------------------------------------------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: null });
  };
  const handleToggleWhatsApp = (e) => {
    setFormData({ ...formData, whatsApp: e.target.checked ? "Yes" : "No" });
  };
  const handleToggleLinkedIn = (e) => {
    const checked = e.target.checked;
    setFormData({
      ...formData,
      includeLinkedIn: checked,
      linkedInProfile: checked ? formData.linkedInProfile : "",
    });
    setErrors({ ...errors, linkedInProfile: null });
  };
 const handleChangeOtp = (e, index) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value.slice(-1);
      setOtp(newOtp);
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };
  const handleKeyDownOtp = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };
return (
    <Modal show={show} onHide={()=>{
      resetAllStates();
    close();}
    }
    backdrop={isForceLogin?"static":true}
    keyboard={!isForceLogin}
    centered>
      {/* if the page is for login then show below heading */}
      {LoginPage && (
        <Modal.Header closeButton={!isForceLogin}>
          <Modal.Title>
           <h3>Login to rent or buy property with ease.</h3>
          </Modal.Title>
        </Modal.Header>
      )}
      {!LoginPage && (
        <Modal.Header closeButton={!isForceLogin}>
          <Modal.Title>
            <h3>Register and find the perfect property with ease!</h3>
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        <div className="modal-form-body">
          {/* if user clicks login show this form */}
          {LoginPage &&
            (apiError ? (
              <ErrorHandlingDesign errorMessage={apiError} />
            ) : (
              <Form>
                {!isOtpFormActive ? (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Number</Form.Label>

                      <PhoneInput
                        international
                        defaultCountry="IN"
                        id="contact-number"
                        type="text"
                        maxLength="15"
                        name="login-number"
                        placeholder="Enter your phone number"
                        value={contactNumber}
                        onChange={setContactNumber}
                        onKeyDown={(e)=>handleEnterKeyPressForPhone(e,"login")}
                      />
                      {contactError && (
                        <div className="text-danger">{contactError}</div>
                      )}
                      {apiError && (
                        <div className="text-danger">{apiError}</div>
                      )}
                    </Form.Group>
                    {isLoggedIn ? (
                      <div className="alert alert-danger" role="alert">
                        User does not exist !
                      </div>
                    ) : (
                      ""
                    )}
                    <Button
                      type="button"
                      className="btn btn-theme-blue w-100"
                      onClick={()=>handleRequestOtp("login")}
                      disabled={isRequestOtpDisabled}
                    >
                      {isRequestOtpDisabled
                        ? "Requesting OTP..."
                        : "Request OTP"}
                    </Button>
                  </>
                ) : (
                  <div className="otp-form mt-4">
                    <div className="d-flex gap-3 justify-content-center">
                      {otp.map((digit, index) => (
                        <Form.Group key={index} className="mb-3 otp-input">
                          <Form.Control
                            id={`otp-digit-${index}`}
                            type="number"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => {
                              const value = e.target.value.slice(0, 1);
                              handleOtpChange(index, value);
                            }}
                            onKeyDown={(e) => {
                              handleKeyDown(index, e);
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleSubmitOtp("login");
                              }
                            }}
                          />
                        </Form.Group>
                      ))}
                    </div>
                    {otpError && (
                      <div className="alert alert-danger">{otpError}</div>
                    )}

                    <div className="resend-button-wrraper">
                      {canResendOtp ? (
                        <button
                          type="button"
                          className="resend-otp mb-2"
                          onClick={handleResendOtp}
                        >
                          Resend OTP
                        </button>
                      ) : (
                        <div className="mt-2 mb-2">
                          Resend OTP in {resendTimer} seconds
                        </div>
                      )}
                    </div>

                    <Button
                      type="button"
                      className="btn btn-theme-blue w-100"
                      onClick={()=>handleSubmitOtp("login")}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                )}
              </Form>
            ))}

          {/* if he/she is a new user then for register show this form       */}
          {!LoginPage && (
            <Form>
              {!isOtpFormActive?(
               <>
              <Row>
               <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder="Enter your First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      isInvalid={!!errors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">
                                                  {errors.firstName}
                                                </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      
                      placeholder="Enter your Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                      isInvalid={!!errors.lastName}
                    />
                      <Form.Control.Feedback type="invalid">
                                                  {errors.lastName}
                                                </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact Number</Form.Label>
                    <PhoneInput
                      international
                      defaultCountry="IN"
                      id="phone-number"
                      type="text"
                      maxLength="15"
                      name="phoneNo"
                      placeholder="Enter your phone number"
                      value={formData.phoneNo}
                       onChange={(value) => {
                                setFormData({ ...formData, phoneNo: value });
                                setErrors({ ...errors, phoneNo: null });
                              }}
                    />
                   {errors.phoneNo && (
                              <div className="text-danger">
                                {errors.phoneNo}
                              </div>
                            )}
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your email address"
                      name="emailAddress"
                      value={formData.emailAddress}
                      onChange={handleChange}
                      isInvalid={!!errors.emailAddress}

                    />
                    <Form.Control.Feedback type="invalid">
                                                 {errors.emailAddress}
                                               </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col lg={12}>
                 {registerError ? (
                            <div className="alert alert-danger" role="alert">
                              {registerError}
                              <br></br>
                               <span
              className="text-danger fw-bold cursor-pointer"
              onClick={() => {resetAllStates(); SetLoginPage(true)}}
            >
             Please Log in.
            </span>
                            </div>
                          ) : (
                            ""
                          )}
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <div className="whatsapp-wrraper">
                      <Form.Check
                        className="option-toggle p-0"
                        type="switch"
                        id="whatsapp-toggle-popup"
                        label=""
                        checked={formData.whatsApp === "Yes"}
                        onChange={handleToggleWhatsApp}
                      />
                      <span className="option-toggle-text">If WhatsApp?</span>
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <div className="whatsapp-wrraper">
                      <Form.Check
                        className="option-toggle p-0"
                        type="checkbox"
                        id="linkedin-toggle-popup"
                        label=""
                        checked={formData.includeLinkedIn}
                        onChange={handleToggleLinkedIn}
                      />
                      <label
                        htmlFor="linkedin-toggle-popup"
                        className="option-toggle-text"
                      >
                        LinkedIn Profile
                      </label>
                    </div>
                  </Form.Group>
                </Col>
                {formData.includeLinkedIn && (
                  <Col lg={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>LinkedIn Profile URL</Form.Label>
                      <Form.Control
                        type="text"
                        name="linkedInProfile"
                        placeholder="https://www.linkedin.com/in/your-profile"
                        value={formData.linkedInProfile}
                        onChange={handleChange}
                        maxLength={200}
                        isInvalid={!!errors.linkedInProfile}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.linkedInProfile}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <Button type="button" className="btn btn-theme-blue w-100"
              disabled={isRequestOtpDisabled}
              onClick={()=>handleRequestOtp("register") }>
                {isRequestOtpDisabled?"Requesting OTP":"Request OTP"}
                
              </Button>

              <br />

              <p>
                <b>Note:</b> Name should match your Aadhaar Name.
              </p>
              </>
              )
              :
              (
                <>
              
              <div className="otp-form mt-4">
                <div className="d-flex gap-3 justify-content-center">
                  {otp.map((_, index) => (
                                          <Form.Group key={index} className="mb-3 otp-input">
                                            <Form.Control
                                              ref={(el) => (inputRefs.current[index] = el)}
                                              type="text"
                                              maxLength="1"
                                              value={otp[index]}
                                              onChange={(e) => handleChangeOtp(e, index)}
                                              onKeyDown={(e) => handleKeyDownOtp(e, index)}
                                            />
                                          </Form.Group>
                                        ))}
                </div>

                <div className="resend-button-wrraper">
                  {resendTimer > 0 ? (
                        <p className="mb-2">Time remaining: {resendTimer} seconds</p>
                      ) : (
                        <p></p>
                      )}
                      {canResendOtp && (
                        <button
                          onClick={handleResendOtp}
                          className="resend-otp mb-2"
                        >
                          Resend OTP
                        </button>
                      )}
                      {otpError && <p className="text-danger">{otpError}</p>}
                        </div>
                  <Button
                                      onClick={()=>handleSubmitOtp("register")}
                                      className="btn btn-theme-blue w-100"
                                      disabled={isSubmitting}
                                    >
                                      {isSubmitting ? "Submitting..." : "Submit"}
                                    </Button>
              </div>
              </>
              )
}
            </Form>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        {LoginPage && (
          <div class="dont-have-account">
            <span>Don't have an account?</span>{" "}
            <span
              className="text-danger fw-bold cursor-pointer"
              onClick={() =>{resetAllStates(); SetLoginPage(false);}}
            >
              Register Now
            </span>
            .
          </div>
        )}
        {!LoginPage && (
          <div class="dont-have-account">
            <span>Already have an account?</span>{" "}
            <span
              className="text-danger fw-bold cursor-pointer"
              onClick={() => {resetAllStates(); SetLoginPage(true)}}
            >
              Log in.
            </span>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
}
